/**
 * V93 — Comprehensive SEO coverage data for the Home Tuition city pages.
 *
 * Every entry here becomes an on-page chip (renders in CityLanding.jsx)
 * AND is picked up by search-engine crawlers as internal link + keyword
 * hit. Consolidated in one file so future additions are one-line changes.
 *
 * Intentionally excludes anything already covered by the existing BOARDS,
 * COURSES, and areas arrays — those keep rendering as before. This file
 * ONLY adds new coverage on top of what's already there.
 */

// Class-level coverage — Nursery → Class 12 (nothing is displayed with a
// board attached because the parent page is already board-agnostic).
export const CLASS_COVERAGE = [
    { slug: "nursery", label: "Nursery" },
    { slug: "lkg", label: "LKG" },
    { slug: "ukg", label: "UKG" },
    { slug: "kindergarten", label: "Kindergarten" },
    { slug: "preschool", label: "Preschool" },
    { slug: "class-1", label: "Class 1" },
    { slug: "class-2", label: "Class 2" },
    { slug: "class-3", label: "Class 3" },
    { slug: "class-4", label: "Class 4" },
    { slug: "class-5", label: "Class 5" },
    { slug: "class-6", label: "Class 6" },
    { slug: "class-7", label: "Class 7" },
    { slug: "class-8", label: "Class 8" },
    { slug: "class-9", label: "Class 9" },
    { slug: "class-10", label: "Class 10" },
    { slug: "class-11", label: "Class 11" },
    { slug: "class-12", label: "Class 12" },
    { slug: "primary", label: "Primary Classes" },
    { slug: "middle-school", label: "Middle School" },
    { slug: "secondary", label: "Secondary School" },
    { slug: "higher-secondary", label: "Higher Secondary" },
];

// Board / curriculum coverage — extends the existing BOARDS grid.
export const CURRICULUM_COVERAGE = [
    "CBSE", "ICSE", "ISC", "MP Board", "Maharashtra Board", "State Board", "NIOS",
    "IGCSE", "IB", "Cambridge", "Edexcel", "A Levels", "GCSE",
    "AP Curriculum", "American Curriculum", "British Curriculum", "International Curriculum",
];

// Subject coverage — one flat list rendered as chips + internal links to
// the /courses page (where a matching program exists) OR to a search
// query on the /online-classes page for niche subjects.
export const SUBJECT_COVERAGE = [
    "Mathematics", "Science", "Physics", "Chemistry", "Biology",
    "English", "Hindi", "Sanskrit", "Marathi",
    "Social Science", "History", "Geography", "Civics", "Political Science",
    "Economics", "Accountancy", "Business Studies", "Statistics", "Commerce",
    "Finance", "Entrepreneurship", "Psychology", "Sociology", "Philosophy",
    "Computer Science", "Informatics Practices",
    "Artificial Intelligence", "Coding", "Programming", "Java", "Python", "C++",
    "Spoken English", "IELTS", "TOEFL", "PTE",
    "French", "German", "Spanish", "Japanese",
    "Drawing", "Music", "Chess", "Vedic Maths", "Abacus", "Handwriting Improvement",
];

// Entrance-exam coverage — 1:1 coaching keywords.
export const ENTRANCE_EXAM_COVERAGE = [
    "JEE", "JEE Main", "JEE Advanced", "NEET", "IIT Foundation",
    "Foundation Classes", "Olympiads", "NTSE", "KVPY",
    "CUET", "CLAT", "NDA", "SSC", "Banking", "UPSC Foundation", "Polytechnic",
];

// Search-intent phrases — these are pure content chips (no link) that
// add semantic coverage for long-tail queries picked up by Google, Bing,
// ChatGPT, Gemini, Claude, Perplexity and voice search.
export const SEARCH_INTENT_COVERAGE = [
    "Best Home Tuition", "Affordable Home Tuition", "Premium Home Tuition",
    "Home Tutor Near Me", "Home Tuition Near Me", "Tuition at Home",
    "Home Tuition for Kids", "Home Tuition for Adults",
    "Individual Tuition", "Personalized Learning",
    "Weekend Home Tuition", "Daily Home Tuition", "Evening Tuition", "Morning Tuition",
    "Crash Course", "Exam Preparation", "Board Exam Preparation",
    "Doubt Solving", "Assignment Help", "Homework Help", "Revision Classes",
    "Test Preparation", "Top Home Tutor", "Expert Home Tutor",
    "Qualified Tutor", "Certified Tutor", "Doorstep Tuition",
    "Offline Tuition", "Home Coaching", "Tuition Teacher at Home", "Personalized Tuition",
];
